import * as Yup from 'yup';

export const validationFormSchema = Yup.object().shape({
  description: Yup.string().required('Required').nullable(),
});
